import { render } from "./My.vue?vue&type=template&id=7c0e5fdb&scoped=true&ts=true&lang=pug"
import script from "./My.vue?vue&type=script&lang=ts&setup=true"
export * from "./My.vue?vue&type=script&lang=ts&setup=true"

import "./My.vue?vue&type=style&index=0&id=7c0e5fdb&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0e5fdb"]])

export default __exports__